import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { softwareListEmbedClassicRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/softwareListEmbedClassicRoute.tsx';
import { ListEmbedSkeleton } from '@atlassian/jira-skeletons/src/ui/list/ListSkeleton.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { projectCreatePermissionsResource } from '@atlassian/jira-router-resources-project-permissions/src/services/project-permissions/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { fieldsResource } from '@atlassian/jira-router-resources-business-fields/src/index.tsx';
import { LazyIssueApp } from '@atlassian/jira-lazy-issue-app/src/LazyIssueApp.tsx';
import { navigationResource } from '@atlassian/jira-router-resources-business-navigation/src/index.tsx';
// eslint-disable-next-line camelcase
import { DEPRECATED_DO_NOT_USE_projectDetailsResource } from '@atlassian/jira-router-resources-business-project-details/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@atlassian/jira-capabilities/src/constants.tsx';
import { getRouteReporting } from '@atlassian/jira-router-routes-issue-navigator-entries/src/common/getRouteReporting.tsx';
import { getCommonProjectResources } from '@atlassian/jira-router-routes-issue-navigator-entries/src/common/getCommonProjectResources.tsx';
import { issueNavigatorEmbedPageEntryPoint } from '@atlassian/jira-router-routes-issue-navigator-entries/src/ui/index.tsx';
import { EmbedIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/embed-app.tsx';
import { softwareListEmbedRouteEntry } from './ui/software/list/index.tsx';

export const softwareListEmbedClassicRouteEntry = createEntry(
	softwareListEmbedClassicRoute,
	() => ({
		group: 'classic-software',

		meta: fg('jira_list_nin_merge')
			? {
					capability: NIN_NEW_ISSUE_NAVIGATOR,
					reporting: getRouteReporting(),
				}
			: undefined,

		skeleton: fg('jira_list_nin_merge') ? EmbedIssueNavigatorSkeleton : ListEmbedSkeleton,

		entryPoint() {
			if (fg('jira_list_nin_merge')) {
				return issueNavigatorEmbedPageEntryPoint;
			}
			return softwareListEmbedRouteEntry;
		},

		layout: chromelessLayout,

		// TODO: This is a copy of getProjectViewResources, but it has been copied in order to expand getNavigationSidebarProjectResource
		resources: fg('jira_list_nin_merge')
			? getCommonProjectResources()
			: [
					// the below 5 resources are copied from getBusinessProjectResources
					// they should be feature flagged and removed when it is safe to do so or
					// moved out of business packages
					// start getBusinessProjectResources
					projectCreatePermissionsResource,
					navigationResource,
					// eslint-disable-next-line camelcase
					DEPRECATED_DO_NOT_USE_projectDetailsResource,
					// end getBusinessProjectResources
					...getNavigationResources(),
					// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
					incidentExperimentTraitResource,
					projectContextResource,
					forgeProjectModuleResource,
					staticSidebarShortcutsResource,
					staticProjectSidebarNavigationResource,
					staticProjectSidebarConnectAddonsNavigationResource,
					// end of resources expanded from getNavigationSidebarProjectResource
					fieldsResource,
				],

		// eslint-disable-next-line jira/ff/no-preconditioning
		isHydrateRootEnabled: fg('nin-full-page-hydrate-root') && fg('jira_list_nin_merge'),

		afterPaint: fg('jira_list_nin_merge') ? undefined : [LazyIssueApp],
		ufoName: fg('jira_list_nin_merge') ? 'classic-list-nin-embed' : 'classic-list-embed',

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-classic-projects-entries/src/softwareListEmbedClassicRouteEntry.tsx',
				whichExportToUse: 'softwareListEmbedClassicRouteEntry',
			},

			enabled: true,
		},
	}),
);
